module.exports = __webpack_public_path__ + "img/Hr数据采集.ce1bfcfc.svg";